import React from "react";

import Typography from "veneer/Typography";

import ConnectionChart, { ConnectionChartPoint } from "./ConnectionChart";

interface ConnectionChartWrapperProps {
  connectionData: ReadonlyArray<ConnectionChartPoint>;
  isShell: boolean;
}

export default function ConnectionChartWrapper({
  connectionData,
  isShell,
}: ConnectionChartWrapperProps) {
  if (isShell) {
    return <Typography variant="body2">Never connected</Typography>;
  }

  return <ConnectionChart data={connectionData} small />;
}
